import React from "react";
import "./Css/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing-page">

      <div className="pricing-header">
        <h1>AKES Software Plans</h1>
      </div>

      <div className="pricing-container">

        <div className="pricing-card">
          <h2>Basic Plan</h2>
          <p className="price">₹2500 <span>/ year</span></p>

          <div className="features-list">
            <p>✔ Online Exam System</p>
            <p>✔ Result Analysis</p>
            <p>✔ Teacher Dashboard</p>
            <p>✔ Student Portal</p>
          </div>

          <button
            className="purchase-btn"
            // onClick={() => window.open("https://institute.akessoft.in", "_blank")}
          >
            Purchase
          </button>        </div>

      </div>

    </div>
  );
};

export default Pricing;